import { useGetPracticeProspectsForSelectQuery, useGetTagsQuery } from '../../../services';
import { parseProspectToOption } from '../../../utils';
import AnalyticsFilters from './AnalyticsFilters';

const AnalyticsSidebarContent = () => {
  const { data: prospects = [], isLoading: isProspectsLoading } = useGetPracticeProspectsForSelectQuery({});
  const { data: tags = [], isLoading: isTagsLoading } = useGetTagsQuery();

  const prospectOptions = prospects.map((prospect) => parseProspectToOption(prospect));
  const tagOptions = tags.map(({ id, name, color }) => ({ value: id, label: name, color }));

  return (
    <AnalyticsFilters
      tagOptions={tagOptions}
      prospectOptions={prospectOptions}
      isTagsLoading={isTagsLoading}
      isProspectsLoading={isProspectsLoading}
    />
  );
};

export default AnalyticsSidebarContent;
